export const SL_MORE_INFO = 'session.lock.more_info';
export const SL_LESS_INFO = 'session.lock.less_info';
export const SL_STORE_SCHEDULE = 'session.lock.store_schedule';
